import axios from "axios";

export async function GetUser( isAuthenticated, user )  {
    let userData = {
        email: "",
        firstName: "",
        lastName: "",
        avatar: "",
        id: null,
        premium: false,
        premiumUntil: null,
        subscriptionLevel: '',
        hasTwoInterviewsThisMonth: false,
        subscriptionId: null,
        subscriptionStatus: 'inactive',
    };

    if (isAuthenticated) {

        userData = {
            email: user.primaryEmailAddress.emailAddress,
            firstName: "",
            lastName: "",
            avatar: user.imageUrl,
            id: null,
            premium: false,
            premiumUntil: null,
            subscriptionLevel: 'Basic',
            hasTwoInterviewsThisMonth: false,
            subscriptionId: null,
            subscriptionStatus: 'inactive',
        };
        const apiUrl = process.env.REACT_APP_BACKEND_URL + "/api/auth/signup";
        try {
            let response = await axios.post(
                apiUrl, { email: user.primaryEmailAddress.emailAddress}
            )
            if (response.data.registered){
                userData.id = response.data.data.id;
                userData.firstName = response.data.data.first_name;
                userData.lastName = response.data.data.last_name;
                userData.premium = response.data.data.premium || false;
                userData.premiumUntil = response.data.data.premiumUntil ? new Date(response.data.data.premiumUntil) : new Date();
                userData.subscriptionLevel = response.data.data.subscriptionLevel || 'Basic';
                userData.hasTwoInterviewsThisMonth = response.data.data.hasTwoInterviewsThisMonth;
                userData.subscriptionId = response.data.data.subscriptionId || null;
                userData.subscriptionStatus = response.data.data.subscriptionStatus || 'inactive';
            }
            return userData;
        } catch(error) {
            console.error("Error saving message:", error);
        }
    } 

    return userData;
}